import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const Container = styled(Box)(({ theme, borderColor }) => ({
    position: "relative",
    margin: "auto",
    borderColor: borderColor || theme.palette.common.black,
    borderWidth: "7px",
    borderStyle: "solid",
    borderRadius: "2.5rem",
    boxShadow: theme.shadows[5],
}));

const Screen = styled(Box)({
    position: 'relative',
    borderRadius: "2rem",
    overflow: "hidden",
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

const StatusBar = styled("img")({
    position: 'absolute',
    top: 0,
    width: '100%',
    zIndex: 99
});

const SmartphoneMockup = ({
    children,
    height,
    width = "auto",
    borderColor = "black"
}) => {
    return (
        <Container
            borderColor={borderColor}
            sx={{
                height: height || "auto",
                width: width === "auto" && !height ? "fit-content" : width,
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "148px",
                    height: "18px",
                    backgroundColor: borderColor,
                    borderBottomLeftRadius: "1rem",
                    borderBottomRightRadius: "1rem",
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    height: "46px",
                    width: "3px",
                    backgroundColor: borderColor,
                    top: "124px",
                    left: "-10px",
                    borderTopLeftRadius: "0.375rem",
                    borderBottomLeftRadius: "0.375rem",
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    height: "46px",
                    width: "3px",
                    backgroundColor: borderColor,
                    top: "178px",
                    left: "-10px",
                    borderTopLeftRadius: "0.375rem",
                    borderBottomLeftRadius: "0.375rem",
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    height: "64px",
                    width: "3px",
                    backgroundColor: borderColor,
                    top: "142px",
                    right: "-10px",
                    borderTopRightRadius: "0.375rem",
                    borderBottomRightRadius: "0.375rem",
                }}
            />
            <Screen>
                <StatusBar src={require('../assets/img/iphone_status_bar.png')} />
                {children}
            </Screen>
        </Container>
    );
};

SmartphoneMockup.propTypes = {
    children: PropTypes.node,
    height: PropTypes.string,
    width: PropTypes.string,
    borderColor: PropTypes.string,
};

export default SmartphoneMockup;
